function ptwUpdateCartNote(note) {
  var giftAttr = note
    ? 'gift-note\n' + note
    : '';

  var body = new URLSearchParams();
  body.set('attributes[gift-note]', giftAttr);
  body.set('note', note || '');

  return fetch(window.Shopify.routes.root + 'cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      'Accept': 'application/json'
    },
    body
  }).then(function (r) { return r.json(); });
}

function ptwAfterWrapinLoadHook() {
  var $ = window.jQuery;

  // UI tweaks
  $('.ptw-gift-image').prependTo('.ptw-app-label label');
  $('#ptw-add-gift-pro')
    .attr({ id: 'ptw-add-gift-pro-ck', type: 'button' })
    .removeClass('button');

  // Add gift wrap variant and mark the cart as gift-wrapped (no notes)
  $('#ptw-add-gift-pro-ck').on('click', function () {
    var variantId = $('#ptw-variant-id').val();

    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      dataType: 'json',
      data: {
        items: [{ quantity: 1, id: variantId }]
      }
    }).done(function () {
      var body = new URLSearchParams();
      body.set('attributes[gift-wrapped]', 'true'); // no gift-note / order note

      fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
          'Accept': 'application/json'
        },
        body
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          document.dispatchEvent(new CustomEvent('theme:cart:refresh'));
        });
    });
  });

  $('#giftNoteCta').on('click', function (e) {
    e.preventDefault();
    var noteVal = $('#gift-note').val() || '';
    var $btn = $(this);
    var originalText = $btn.text();
    $btn.text('Gift Note Added!');

    ptwUpdateCartNote(noteVal.trim()).then(function () {      
      setTimeout(function () {
        $btn.text(originalText);
        $('#gift-note').val('');
      }, 1000);
    });
  });  
}

window.addEventListener('pageshow', function () {  
  // re-read the cart and if note exists but attribute is missing, reapply it
  fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      var note = cart.note || '';
      var hasAttr = cart.attributes && cart.attributes['gift-note'];            
      if (note && !hasAttr) {
        return ptwUpdateCartNote(note);
      }
    })    
    .catch(function (err) {
      console.warn('gift-note resync failed', err);
    });
});